import React, {Component} from 'react';
import edap from '../../utils/edap';

let withPAR = (WrappedComponent) => {
    let namedWrappedComponent = class extends Component {
        constructor(props) {
            super(props);
            this.isMarked = false;
        }

        componentWillMount() {
            this.isMarked = false;
        }

        markPAR = () => {
            if (!this.isMarked) {
                this.isMarked = true;
                edap.markPAR();
            }
        }

        render() {
            return <WrappedComponent {...this.props} markPAR={this.markPAR} />;
        }
    };

    /* istanbul ignore next */
    namedWrappedComponent.displayName = `withPAR(${WrappedComponent.displayName ||
        WrappedComponent.name ||
        'Component'})`;
    return namedWrappedComponent;
};

export default withPAR;



// WEBPACK FOOTER //
// ./src/universal/components/Timing/withPAR.js